const generalPT = {
    "modalConfirm": {
        "button": {
            "cancel": "Cancelar",
            "confirm": "Confirmar"
        }
    },
    "tableDropdown": {
        "action": "Ação",
        "edit": "Editar",
        "delete": "Excluir",
        "viewDetails": "Ver Detalhes",
        "copyMLId": "Copiar ID ML",
        "viewStats": "Ver Estatísticas"
    },
    "tableModal": {
        "cancel": "Cancelar",
        "confirm": "Confirmar",
        "edit": "Editar"
    },
    "invoiceModal": {
        "button": {
            "cancel": "Cancelar",
            "confirm": "Confirmar"
        }
    },
    "select": {
        "placeholder": "Selecionar..."
    },
    "asyncDropdown": {
        "placeholder": "Pesquisar...",
        "loading": "Carregando...",
        "noResults": "Sem opções",
        "blacklisted": "Na lista negra"
    },
    "table": {
        "noDataAvailable": "Nenhum dado disponível"
    },
    "tableHelper": {
        "loading": "Carregando...",
        "error": "Ocorreu um erro",
        "noData": "Não há dados disponíveis"
    },
    "countriesSelect": {
        "placeholder": "Pesquisar país..."
    },
    "consentModal": {
        "header": "Consentimento Necessário",
        "body": {
            "description": "Por favor, revise e aceite nossos novos termos de consentimento para continuar usando nossos serviços.",
            "label": {
                "firstName": "Nome",
                "lastName": "Sobrenome",
                "email": "Email",
                "termsOfUsageAgreement": "Eu concordo com os <1>Termos de Uso</1>",
                "privacyPolicyAgreement": "Eu concordo com a <1>Política de Privacidade</1>",
                "cookiePolicyAgreement": "Eu concordo com a <1>Política de Cookies</1>"
            }
        },
        "button": {
            "submit": "Enviar"
        }
    },
    "passwordResetModal": {
        "header": "Altere Sua Senha",
        "body": {
            "form": {
                "label": {
                    "currentPassword": "Senha atual",
                    "newPassword": "Nova senha",
                    "repeatNewPassword": "Repita a nova senha"
                },
                "button": {
                    "submit": "Enviar"
                },
                "message": {
                    "currentPasswordRequired": "Sua senha antiga é necessária",
                    "newPasswordRequired": "Nova senha é necessária",
                    "newPasswordMinLength": "Sua senha deve ter pelo menos 10 caracteres",
                    "newPasswordDifferentFromOld": "A nova senha deve ser diferente da senha antiga",
                    "newPasswordConfirmation": "A nova senha deve coincidir"
                }
            }
        },
        "footer": {
            "note": "<strong>Nota: </strong>Faz um tempo desde que você atualizou sua senha pela última vez. Para sua segurança, por favor, redefina sua senha."
        },
        "message": {
            "success": "Sua senha foi alterada!",
            "error": "Algo deu errado! Por favor, atualize a página e tente novamente!"
        },
        "modal": {
            "confirm": {
                "header": "Tem certeza de que gostaria de mudar sua senha?",
                "body": "Por favor, confirme"
            }
        }
    },
    "qcFeedback": {
        "label": {
            "qcFeedback": "Feedback de QC"
        }
    },
    "subUserFilter": {
        "label": {
            "subUser": "Sub-Usuário: "
        },
        "placeholder": {
            "subUser": "Selecionar Sub-Usuário"
        },
        "button": {
            "reset": "Redefinir"
        }
    },
    "footer": {
        "label": {
            "copyright": "Copyright © {{year}}",
            "allRightsReserved": "Todos os direitos reservados.",
            "privacyPolicy": "Política de Privacidade",
            "termsAndConditions": "Termos e Condições"
        }
    },
    "promoBannerHeader": {
        "exclusiveOfferFor": "Oferta Exclusiva para",
        "off": "OFF",
        "promoCode": "Código Promocional",
        "expiresIn": "Expira em",
        "clickHereToAvailThisOffer": "Clique aqui para aproveitar esta oferta",
        "availableOnAllSubscriptionPlans": "Disponível em todos os planos de assinatura."
    },
    "promoBanner": {
        "exclusiveOfferFor": "Oferta Exclusiva para",
        "off": "OFF",
        "limitedTimePromoOffer": "Este Código Promocional Temporário foi criado exclusivamente para você. Não perca esta oportunidade!",
        "promoCode": "Seu Código Promocional",
        "expiresIn": "Expira em",
        "days": "Dias",
        "hours": "Horas",
        "minutes": "Minutos",
        "seconds": "Segundos",
        "availableOnAllSubscriptionPlans": "Esta oferta exclusiva está disponível em todos os planos de assinatura."
    }
};

export default generalPT;